import { render } from "./PlayerPeformance.vue?vue&type=template&id=c8e0166e&scoped=true"
import script from "./PlayerPeformance.vue?vue&type=script&lang=js"
export * from "./PlayerPeformance.vue?vue&type=script&lang=js"

import "./PlayerPeformance.vue?vue&type=style&index=0&id=c8e0166e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8e0166e"]])

export default __exports__